import { Link } from 'react-router-dom';
import './footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-grid">
          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/why-choose">Why Choose</Link></li>
              <li><Link to="/events">Events</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-col footer-contact">
            <h4>Contact</h4>
            <p>
              <i className="fas fa-envelope" aria-hidden="true"></i>
              <a href="mailto:Info@ignitevents.ie">Info@ignitevents.ie</a>
            </p>
            <p>
              <i className="fas fa-phone-alt" aria-hidden="true"></i>
              <a href="tel:+353873831780">087 383 1780</a> (Alison)
            </p>
            <p>
              <i className="fas fa-phone-alt" aria-hidden="true"></i>
              <a href="tel:+353872867880">087 286 7880</a> (Willie)
            </p>
          </div>

          <div className="footer-col footer-socials">
            <h4>Follow Us</h4>
            <div className="social-links">
              <a href="https://www.instagram.com/ignite_event_management/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://www.linkedin.com/company/111603380/admin/dashboard/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copy">&copy; {new Date().getFullYear()} Ignite Event Management. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
